import { useQuery } from "react-query";
import { toast } from "react-toastify";
import {  getOrderRequests } from "api/Employee";

interface Props {
    id?: string;
}

export const useOrderRequests = ({id}: Props) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['orderRequests'],
        () => {
            return getOrderRequests({id:id});
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
